export const getNumericPhoneNumber = (phone: string | null = ""): string => {
  if (!phone) {
    return "";
  }
  const numericPhoneNumber = phone.replace(/\D/g, "");
  return numericPhoneNumber;
};
